import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { ClienteAnaliseMercadoPeriodicidadeFilterComponent } from './cliente-analise-mercado-periodicidade-filter.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteAnaliseMercadoPeriodicidadeFilterComponent
    ],
    exports: [
        ClienteAnaliseMercadoPeriodicidadeFilterComponent
    ]
})
export class ClienteAnaliseMercadoPeriodicidadeFilterModule { }
